export default "__VITE_ASSET__Bp8mKxxU__"